import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { string } from 'prop-types';
import { resendTempPassword } from '../../../services/Api/User/UserService';

const EmailSentModal = ({ email }) => {
  const { t } = useTranslation();
  const [showLoader, setLoader] = useState(false);
  const [notification, setNotification] = useState('');

  const handleSubmit = async event => {
    event.preventDefault();
    setLoader(true);
    try {
      await resendTempPassword(email);
      setLoader(false);
    } catch (err) {
      setLoader(false);
      setNotification(
        err.response.data ? err.response.data.message : 'Something went wrong.'
      );
      setTimeout(() => {
        setNotification('');
      }, 4000);
    }
  };

  return (
    <div className="emailSend">
      {notification && (
        <div className="notification visible">
          {notification}
          <span className="close-button" onClick={() => setNotification('')}>
            ×
          </span>
        </div>
      )}
      <h1 id="dialogTitleHeading">{t('Email sent!')}</h1>
      <p>
        {t('Check your inbox for a link to ')}
        <br className="mobile-only" /> {t('reset your')}
        <br className="desktop-only" /> {t('password.')}
      </p>
      {showLoader ? (
        <img
          src="/content/images/loader/loading.gif"
          alt="loader"
          className="searchBarLoader"
        />
      ) : (
        <button onClick={handleSubmit} className="dialogComponent resendEmail">
          {t('Resend email')}
        </button>
      )}
    </div>
  );
};

EmailSentModal.propTypes = {
  email: string
};

export default EmailSentModal;
